export const ListQueryKey = 'allowance_list';
export const DetailQueryKey = 'allowance';
export const Urls = {
  selectUrl: '/captainsalary/list',
  updateUrl: '/captainsalary/update',
  deleteUrl: '/captainsalary/delete',
  createUrl: '/captainsalary/create',
  detailUrl: '/captainsalary/detail'
};